export const SOLICITUD_ESTADOS = {
	BORRADOR: 0,
	ENVIADA: 1,
	EN_CURSO: 2,
	FINALIZADA: 3,
	CANCELADA: 4,
};

export const SOLICITUD_ESTADOS_COLOR = {
	0: 'gray-50',
	1: 'orange-50',
	2: 'blue-50',
	3: 'green-40',
	4: 'red-50',
};

export const TIPO_SUJETO = {
	SUJETO_PASIVO: 1,
	SUJETO_TRASMITENTE: 2,
};

export const TIPO_PERSONA = {
	FISICA: 1,
	JURIDICA: 2,
};

export const TIPO_DIRECCION = {
	SIN_DIRECCION: 0,
	NACIONAL: 1,
	EXTRANJERA: 2,
};

export const TIPO_SUBSANACION = {
	SUJETO: 1,
	DOCUMENTO: 2,
	NUEVO_DOCUMENTO: 3,
};

export const ESTADOS_OPERACION = {
	PENDIENTE: 1,
	EN_CURSO: 2,
	FIRMADA: 3,
	FINALIZADA: 4,
	CANCELADA_EF: 5,
	CANCELADA_NOT: 6,
	CANCELADA_VENCIMIENTO: 7,
};

export const ESTADO_SUBSANACION = {
	PENDIENTE: 1,
	SUBSANADA: 2,
	VALIDADA: 3,
	CANCELADA: 4
} as const;

export const TIPO_USUARIO = {
	ADMIN: 1,
	USUARIO: 2,
};

// Solamente para los documentos transversales para todos los tramites
export const TIPO_DOCUMENTO = {
	PODER_REPRESENTANTE: 1,
	OTROS: 29,
};

export const TIPO_DOCUMENTO_IDENT = {
	NIF: 1,
	NIE: 2,
	PASAPORTE: 3
};

export const ID_PAIS = {
	ESPANA: 'ESP'
};

export const ID_PREFIJO_PAIS = {
	ESPANA: '34'
};

export const STEP_ID = {
	DOCUMENTACION: 0,
	SUJETOS: 1,
	SELECCION_NOTARARIO: 2,
	CONFIRMACION: 3,
};

export const ESTADO_COLOR = {
	1: 'orange-50',
	2: 'blue-50',
	3: 'turquoise-50',
	4: 'green-40',
	5: 'black-100',
	6: 'black-100',
	7: 'black-100',
};

export const SUBSANACION_ESTADO_COLOR = {
	0: 'gray-50',
	1: 'orange-50',
	2: 'blue-50',
	3: 'green-40',
	4: 'red-50',
};

export const ESTADOS_FIRMA = {
	PENDIENTE: 1,
	SUBSANADA: 2,
	RECHAZADA: 3,
	CANCELADA: 4
};

export const ESTADO_FIRMA_COLOR = {
	[ESTADOS_FIRMA.PENDIENTE]: 'orange-50', 
	[ESTADOS_FIRMA.RECHAZADA]: 'green-40',
	[ESTADOS_FIRMA.SUBSANADA]: 'green-40',  
	[ESTADOS_FIRMA.CANCELADA]: 'red-50', 
};